import { useEffect, useState, useCallback } from 'react';
import Cookies from 'js-cookie';
import { IWorkspace } from '../types/types';
import FetchData from '../Components/ServerCall/FetchData';

export const useWorkspace = (parentWorkspaceID = '', fetchSubWorkspaces = false) => {
  const [data, setData] = useState<IWorkspace[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<{ message: string; code: number; isError: boolean } | null>(
    null,
  );

  const fetchData = useCallback(async () => {
    if (fetchSubWorkspaces && !parentWorkspaceID) {
      setError({ message: 'Parent Workspace ID is required', code: 400, isError: true });
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await FetchData({
        requestType: 'noData',
        method: 'GET',
        url: !fetchSubWorkspaces ? 'workspace' : `workspace/${parentWorkspaceID}`,
        headers: {
          Authorization: `Bearer ${Cookies.get('authToken')}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.status) {
        sessionStorage.setItem(
          fetchSubWorkspaces ? 'subWorkspaces' : 'workspaces',
          JSON.stringify(response.data),
        );
        setData(response.data as IWorkspace[]);
      } else {
        throw new Error('Error while fetching the data');
      }
    } catch (e: any) {
      setError({
        message: e.message ?? 'Error while fetching the data',
        code: e.code || 500,
        isError: true,
      });
    } finally {
      setLoading(false);
    }
  }, [parentWorkspaceID, fetchSubWorkspaces]);

  useEffect(() => {
    (async function () {
      await fetchData();
    })();
  }, [parentWorkspaceID]);

  return { result: data, loading, error, refetch: fetchData };
};
